import React from "react";
import styled from "styled-components";
import Button from "../components/Button";
import ListWrapper from "../components/ListWrapper";
import PageContainer from "../components/PageContainer";
import ProfileTab from "../components/ProfileTab";
import SectionSelectTab from "../components/SectionSelectTab";
import Text from "../components/Text";
import { breakpoints, colors, columnSize } from "../styles/theme";
import logo from "../assets/logo.svg";
import SwipeBlock from "../components/SwipeBlock";

const Container = styled(PageContainer)`
  display: grid;
  grid-template-columns: ${columnSize} 1fr;
  grid-template-rows: 100vh;

  > div {
    padding: 2rem;
  }

  @media (max-width: ${breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

const Wrapper = styled.div`
  max-width: 1000px;
  text-align: center;
  place-self: center;

  > * {
    margin-bottom: 2rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const Logo = styled.img`
  @keyframes movement {
    from {
      top: 0;
    }
    to {
      top: -20px;
    }
  }

  position: relative;
  width: 100%;
  max-width: 250px;
  animation: movement 1s ease-in-out infinite alternate;
  transition: transform 0.75s;

  &:hover {
    transform: rotate(180deg);
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  > * {
    margin: 0 1rem 0 0;
    &:last-child {
      margin: 0;
    }
  }

  @media (max-width: ${breakpoints.phone}) {
    flex-direction: column;
    > * {
      margin: 0 0 1rem 0;
      &:last-child {
        margin: 0;
      }
    }
  }
`;

const userAgent = navigator.userAgent.toLowerCase();
const isElectron = userAgent.indexOf(" electron/") > -1;
const isMobile =
  /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
const isWindows = userAgent.indexOf("windows") > -1;
const is64bit =
  userAgent.indexOf("wow64") > -1 || userAgent.indexOf("win64") > -1;

export default function Home() {
  return (
    <Container>
      <SwipeBlock
        direction="right"
        breakpoint={breakpoints.tablet}
        style={{
          background: colors.background50,
          borderRight: `1px solid ${colors.background200}`,
        }}
      >
        <ListWrapper withSpacers>
          <ProfileTab />
          <SectionSelectTab />
        </ListWrapper>
      </SwipeBlock>
      <Wrapper>
        <Logo src={logo} alt="Logo" />
        <h4>
          Welcome to{" "}
          <span style={{ color: colors.primary }}>Realtime Chat JS</span>
        </h4>
        <Text size="md">
          Project made for practice purposes with React.js and Electron.js.
          Completely open source and free for everyone. More info on source code
          page.
        </Text>
        <ButtonsContainer>
          {!isElectron &&
            !isMobile &&
            (isWindows ? (
              is64bit ? (
                <Button
                  as="a"
                  href="https://firebasestorage.googleapis.com/v0/b/electron-react-platform.appspot.com/o/rtcjs-win64.zip?alt=media&token=44a212a4-cbf7-426c-a3d1-23cde1cf2927"
                  download="Realtime_Chat_JS_Win64.zip"
                  size="md"
                >
                  Download for Windows
                </Button>
              ) : (
                <Button
                  as="a"
                  href="https://firebasestorage.googleapis.com/v0/b/electron-react-platform.appspot.com/o/rtcjs-win32.zip?alt=media&token=5300580e-32bb-437c-abc3-f3eae514b854"
                  download="Realtime_Chat_JS_Win32.zip"
                  size="md"
                >
                  Download for Windows
                </Button>
              )
            ) : (
              <Button
                as="a"
                href="https://firebasestorage.googleapis.com/v0/b/electron-react-platform.appspot.com/o/rtcjs-linux.zip?alt=media&token=fb071c67-f747-40e0-a0e8-35b7d5ecbb3a"
                download="Realtime_Chat_JS_Linux.zip"
                size="md"
              >
                Download for Linux
              </Button>
            ))}
          <Button
            as="a"
            variant="secondary"
            size="md"
            href="https://github.com/Borys35/electron-react-chatting-platform"
            target="_blank"
          >
            Source code
          </Button>
        </ButtonsContainer>
      </Wrapper>
    </Container>
  );
}
